import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useTheme, styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import { LineChart as LineChart$1, lineElementClasses } from "@mui/x-charts/LineChart";
import { getYAxisWidth } from "../utils/data.js";
const StyledLineChart = styled(LineChart$1, {
  shouldForwardProp: prop => !["showLabels", "areaKey"].includes(prop)
})(({
  theme,
  areaKey,
  showLabels = false
}) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.sizes.spacing["01"],
  margin: theme.sizes.spacing["01"],
  position: "relative",
  // maxHeight: '8.5rem',
  // minWidth: '16rem',
  ["& .MuiChartsSurface-root"]: {},
  [`& .${lineElementClasses.series}`]: {
    stroke: theme.palette.background.paper,
    strokeWidth: 1
  },
  ["& .MuiChartsAxis-root"]: {
    ...(showLabels ? {} : {
      display: "none"
    }),
    "& .MuiChartsAxis-line, & .MuiChartsAxis-tick, .MuiChartsAxis-label": {
      display: "none"
    }
  },
  ["& .MuiChartsLegend-root"]: {
    display: "none"
  },
  ["&:not(.with-labels) .MuiChartsLegend-root"]: {
    color: "red",
    display: "block"
  },
  [`& .MuiAreaElement-series-${areaKey}`]: {
    opacity: 0.3,
    filter: "none",
    fill: "url(#sand-line-gradient)",
    ".color-scheme-forest &": {
      fill: "url(#forest-line-gradient)"
    },
    ".color-scheme-blaze &": {
      fill: "url(#blaze-line-gradient)"
    },
    ".color-scheme-volt &": {
      fill: "url(#volt-line-gradient)"
    }
  }
}));
const LineChart = t0 => {
  const $ = c(47);
  const {
    series,
    xAxis,
    seriesData,
    height,
    showLabels: t1,
    isLoading: t2,
    colorScheme: t3,
    animate: t4
  } = t0;
  const showLabels = t1 === void 0 ? false : t1;
  const isLoading = t2 === void 0 ? false : t2;
  const colorScheme = t3 === void 0 ? "sand" : t3;
  const animate = t4 === void 0 ? false : t4;
  const theme = useTheme();
  const stripNullsAtEnd = _temp2;
  let t5;
  if ($[0] !== colorScheme || $[1] !== isLoading || $[2] !== series || $[3] !== seriesData || $[4] !== showLabels || $[5] !== theme || $[6] !== xAxis) {
    bb0: {
      if (!seriesData || seriesData.length === 0 || isLoading || !series) {
        t5 = null;
        break bb0;
      }
      let t62;
      if ($[8] !== seriesData) {
        let t73;
        if ($[10] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
          t73 = s => ({
            data: stripNullsAtEnd(s?.data)
          });
          $[10] = t73;
        } else {
          t73 = $[10];
        }
        const trimmedSeriesData = seriesData.filter(Boolean).map(t73);
        t62 = Math.min(...trimmedSeriesData.map(_temp3));
        $[8] = seriesData;
        $[9] = t62;
      } else {
        t62 = $[9];
      }
      const shortestLength = t62;
      let t72;
      if ($[11] !== shortestLength) {
        t72 = s_1 => ({
          ...s_1,
          data: s_1?.data?.slice(0, shortestLength) || []
        });
        $[11] = shortestLength;
        $[12] = t72;
      } else {
        t72 = $[12];
      }
      const normalizedSeriesData = seriesData.map(t72);
      let t82;
      if ($[13] !== shortestLength || $[14] !== showLabels || $[15] !== xAxis) {
        let t93;
        if ($[17] !== shortestLength || $[18] !== showLabels) {
          t93 = x => ({
            ...x,
            data: (x.data || []).slice(0, shortestLength),
            position: showLabels ? "bottom" : "none"
          });
          $[17] = shortestLength;
          $[18] = showLabels;
          $[19] = t93;
        } else {
          t93 = $[19];
        }
        t82 = xAxis.map(t93);
        $[13] = shortestLength;
        $[14] = showLabels;
        $[15] = xAxis;
        $[16] = t82;
      } else {
        t82 = $[16];
      }
      const normalizedXAxis = t82;
      if (normalizedXAxis.length === 0 || normalizedXAxis[0]?.data.length === 0) {
        t5 = null;
        break bb0;
      }
      let t92;
      if ($[20] !== colorScheme || $[21] !== series || $[22] !== theme) {
        t92 = (seriesItem, idx) => ({
          ...seriesItem,
          label: series[idx]?.label,
          color: theme.charts.line.colors[colorScheme || "default"][idx]
        });
        $[20] = colorScheme;
        $[21] = series;
        $[22] = theme;
        $[23] = t92;
      } else {
        t92 = $[23];
      }
      t5 = {
        series: normalizedSeriesData.map(t92),
        xAxis: normalizedXAxis
      };
    }
    $[0] = colorScheme;
    $[1] = isLoading;
    $[2] = series;
    $[3] = seriesData;
    $[4] = showLabels;
    $[5] = theme;
    $[6] = xAxis;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const chartData = t5;
  let t6;
  bb1: {
    if (!chartData) {
      let t73;
      if ($[24] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
        t73 = [];
        $[24] = t73;
      } else {
        t73 = $[24];
      }
      t6 = t73;
      break bb1;
    }
    const hasRight = chartData.series.some(_temp4);
    const calcWidth = _temp7;
    const axisFormatter = _temp8;
    if (!hasRight) {
      let t73;
      if ($[25] !== chartData.series || $[26] !== showLabels) {
        t73 = showLabels ? calcWidth(chartData.series) : 0;
        $[25] = chartData.series;
        $[26] = showLabels;
        $[27] = t73;
      } else {
        t73 = $[27];
      }
      const w = t73;
      let t82;
      if ($[28] !== chartData.series || $[29] !== showLabels || $[30] !== w) {
        t82 = [showLabels ? {
          width: w,
          valueFormatter: axisFormatter(chartData.series)
        } : {
          width: w,
          position: "none"
        }];
        $[28] = chartData.series;
        $[29] = showLabels;
        $[30] = w;
        $[31] = t82;
      } else {
        t82 = $[31];
      }
      t6 = t82;
      break bb1;
    }
    let t72;
    if ($[32] !== chartData.series || $[33] !== showLabels) {
      const leftSeries = chartData.series.filter(_temp9);
      const rightSeries = chartData.series.filter(_temp0);
      t72 = [showLabels ? {
        id: "left",
        position: "left",
        width: calcWidth(leftSeries),
        valueFormatter: axisFormatter(leftSeries)
      } : {
        id: "left",
        position: "none",
        width: 0
      }, showLabels ? {
        id: "right",
        position: "right",
        width: calcWidth(rightSeries),
        valueFormatter: axisFormatter(rightSeries)
      } : {
        id: "right",
        position: "none",
        width: 0
      }];
      $[32] = chartData.series;
      $[33] = showLabels;
      $[34] = t72;
    } else {
      t72 = $[34];
    }
    t6 = t72;
  }
  const yAxes = t6;
  if (isLoading) {
    let t72;
    if ($[35] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
      t72 = /* @__PURE__ */jsx(Skeleton, {
        variant: "rectangular",
        width: "100%",
        height: "100%"
      });
      $[35] = t72;
    } else {
      t72 = $[35];
    }
    return t72;
  }
  if (!series) {
    let t72;
    if ($[36] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
      t72 = /* @__PURE__ */jsx(Typography, {
        sx: {
          padding: "10px"
        },
        children: "Configuration is not valid"
      });
      $[36] = t72;
    } else {
      t72 = $[36];
    }
    return t72;
  }
  if (!seriesData || seriesData.length === 0) {
    let t72;
    if ($[37] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
      t72 = /* @__PURE__ */jsx(Typography, {
        sx: {
          padding: "10px"
        },
        children: "No data available for the chart"
      });
      $[37] = t72;
    } else {
      t72 = $[37];
    }
    return t72;
  }
  let t7;
  if ($[38] === /* @__PURE__ */Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      width: "100%"
    };
    $[38] = t7;
  } else {
    t7 = $[38];
  }
  let t8;
  if ($[39] !== animate || $[40] !== chartData || $[41] !== height || $[42] !== showLabels || $[43] !== yAxes) {
    t8 = chartData && /* @__PURE__ */jsx(StyledLineChart, {
      areaKey: chartData.series[0]?.id ?? "",
      series: chartData.series,
      height,
      yAxis: yAxes,
      xAxis: chartData.xAxis,
      grid: {
        horizontal: true,
        vertical: false
      },
      skipAnimation: !animate,
      showLabels,
      hideLegend: !showLabels,
      margin: {
        left: 0,
        right: 0,
        bottom: 0
      },
      className: `${showLabels ? "with-labels" : ""}`
    });
    $[39] = animate;
    $[40] = chartData;
    $[41] = height;
    $[42] = showLabels;
    $[43] = yAxes;
    $[44] = t8;
  } else {
    t8 = $[44];
  }
  let t9;
  if ($[45] !== t8) {
    t9 = /* @__PURE__ */jsx("div", {
      style: t7,
      children: t8
    });
    $[45] = t8;
    $[46] = t9;
  } else {
    t9 = $[46];
  }
  return t9;
};
function _temp(v) {
  return v === null;
}
function _temp2(data) {
  if (!data || data.length === 0 || data.every(_temp)) {
    return data;
  }
  while (data[data.length - 1] === null && data.length > 0) {
    data.pop();
  }
  return data;
}
function _temp3(s_0) {
  return s_0?.data?.length ?? 0;
}
function _temp4(s_2) {
  return s_2.yAxisId === "right";
}
function _temp5(s_3) {
  return s_3.data;
}
function _temp6(v_0) {
  return typeof v_0 === "number";
}
function _temp7(series_0) {
  if (!series_0.length) {
    return 0;
  }
  const max = Math.ceil(Math.max(...series_0.flatMap(_temp5).filter(_temp6)));
  const formatter = series_0[0]?.axisValueFormatter;
  const repr = formatter ? formatter(max) : max.toString();
  return getYAxisWidth(repr.length);
}
function _temp8(subset) {
  return subset[0]?.axisValueFormatter;
}
function _temp9(s_4) {
  return s_4.yAxisId !== "right";
}
function _temp0(s_5) {
  return s_5.yAxisId === "right";
}
export { LineChart as default };